(() => {
  if (window.zfWearMotion) return;
  window.zfWearMotion = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = () => document.querySelectorAll('.zf-wear-guide:not([data-wear-motion])').forEach(guide => {
    guide.dataset.wearMotion = 'ready';
    const cards = [...guide.querySelectorAll('.zf-wear-card')];
    const positions = [[54, 50], [46, 51], [60, 57]];
    cards.forEach((card, i) => {
      const ring = document.createElement('span');
      ring.className = 'zf-wear-pulse';
      ring.setAttribute('aria-hidden', 'true');
      ring.style.cssText = `left:${positions[i][0]}%;top:${positions[i][1]}%;--pulse-delay:${i * 0.65}s`;
      card.querySelector('.zf-wear-photo').append(ring);
    });
    if (!('IntersectionObserver' in window)) return;
    let entered = false;
    const animations = [];
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        guide.classList.toggle('is-in-view', entry.isIntersecting);
        if (!entry.isIntersecting || entered || reduced.matches) return;
        entered = true;
        cards.forEach((card, i) => animations.push(card.animate(
          [{opacity: 0, transform: 'translateY(18px)'}, {opacity: 1, transform: 'translateY(0)'}],
          {duration: 700, delay: i * 100, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards'}
        )));
      });
    }, {threshold: 0.15});
    observer.observe(guide);
    reduced.addEventListener('change', () => {
      if (reduced.matches) animations.forEach(animation => animation.cancel());
    });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(guide)) observer.disconnect();
    });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
